var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field mb-2"},[_c('label',{staticClass:"question-label"},[_vm._v(_vm._s(_vm.questionTitle))]),_c('div',{staticClass:"control ml-2"},[_c(_vm.questionComponent,{tag:"component",attrs:{"question":_vm.question}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }